
import { defineComponent, watch, toRefs } from 'vue'
import { useStore } from 'vuex'
import { loadingCounter } from '@/axios'
import { SUCCESS } from '@/constants'

// components
import Loading from '@/components/Loading/index.vue'
import Popup from '@/components/Popup/index.vue'

// hooks
import usePopup from '@/components/Popup/index.ts'

const {
  isDisplay,
  dataIndex,
  popupTypeName,
  openPopup,
  closePopup
} = usePopup()

function init() {
  const store = useStore()

  watch(
    () => store.state.status.code,
    (newValue: string, oldvalue: string) => {
      if (newValue === SUCCESS) return

      switch (newValue) {
        case '2000':
          openPopup('message', 2)
          break
        case '2001':
          openPopup('message', 3)
          break
        case '2002':
          openPopup('message', 4)
          break
        case '2003':
          openPopup('message', 5)
          break

        default:
          openPopup('loudspeaker', 1)
          break
      }
    }
  )
}

export default defineComponent({
  name: 'App',
  components: { Loading, Popup },
  setup(props, content) {
    init()

    return {
      ...toRefs(dataIndex),
      isDisplay,
      openPopup,
      closePopup,
      popupTypeName,
      loadingCounter
    }
  }
})
